import { useState, useEffect, useMemo } from 'react';
import { 
  DgtPdOrderPicklistExtraReturn,
  ExtraReturnStatus
} from '../models'

import {
  getRequestedReturnPicklists,
  getWhApprovedReturnPicklists,
  getCanceledReturnPicklists
} from '../states/PicklistAction'

import { getDates } from '../utilities/Format'

export default function usePicklistReturn(
  status: ExtraReturnStatus,
  dateFrom: Date,
  dateTo: Date,
  searchByOrder: string
) : DgtPdOrderPicklistExtraReturn[] {
  const [returns, setReturns] = useState<DgtPdOrderPicklistExtraReturn[]>([]);

  useEffect(() => {
    const periodDates = getDates(dateFrom, dateTo)
    Promise.allSettled(periodDates.map(date => {
      if (status === ExtraReturnStatus.NEW) {
        return getRequestedReturnPicklists(date)
      } else if (status === ExtraReturnStatus.APPROVED) {
        return getWhApprovedReturnPicklists(date)
      } else if (status === ExtraReturnStatus.CANCELED) {
        return getCanceledReturnPicklists(date)
      }
      return Promise.reject(`Picklist Status not supported : ${status}`)
    })).then(results => {
      const totalReturns = (results
        .filter(res => res.status === 'fulfilled') as PromiseFulfilledResult<DgtPdOrderPicklistExtraReturn[]>[])
        .reduce((prev, cur) => [...prev, ...cur.value], [] as DgtPdOrderPicklistExtraReturn[])
      setReturns(totalReturns)
    })
    .catch(err => console.error(err))
  }, [ status, dateFrom, dateTo ]);

  const filteredReturns = useMemo(() => returns.filter(ex => ex.orderId.includes(searchByOrder)), [ searchByOrder, returns ])
  return filteredReturns
}